import { EditorState, Entity, AtomicBlockUtils } from 'draft-js';
import { hashFile, readPNGDensity } from 'lib/helpers';
import { updateEntity } from './updateEntity';

const cached = {};

export async function insertImage({ file, store, uploadImage, imageSizeLimit, zipImage }) {
	const { getEditorState, setEditorState } = store;
	const hash = await hashFile(file);
	const dpi = await readPNGDensity(file);
	const name = file.name;

	if (cached[hash]) {
		insertImageEntity({ name, data: cached[hash], getEditorState, setEditorState });
		return;
	}
	const placeHolderUrl = URL.createObjectURL(file);
	let error = null;

	if (!/^image\//.test(file.type)) {
		error = `不正确的图片类型：${file.type}`;
	}

	// 提问图片大小超过限制
	if (file.size > imageSizeLimit) {
		const limitSizeInMb = (imageSizeLimit / 1024 / 1024).toPrecision(2);
		const fileSizeInMb = (file.size / 1024 / 1024).toPrecision(3);
		error = `仅支持不超过 ${limitSizeInMb}M 的图片, 该图片过大(${fileSizeInMb}M)`;
	}

	const entityKey = insertImageEntity({ name, data: { placeHolderUrl, error, dpi }, getEditorState, setEditorState });
	if (error) {
		return;
	}
	try {
		const { url } = await uploadImage(file);
		updateEntity({ entityKey, getEditorState, setEditorState, update: (cached[hash] = {
			imageUrl: url,
			placeHolderUrl: null
		}) });
	} catch (error) {
		error = '上传失败：' + (error.msg || String(error));
		updateEntity({ entityKey, getEditorState, setEditorState, update: { error }});
	}
}

function insertImageEntity({ name, data, getEditorState, setEditorState }) {
	/** @type {EditorState} */
	const editorState = getEditorState();

	const contentState = editorState.getCurrentContent();
	const contentStateWithEntity = contentState.createEntity('IMAGE', 'IMMUTABLE', data);
	const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

	const editorStateWithNewContent = EditorState.set(editorState, { currentContent: contentStateWithEntity });
	const editorStateWithNewAtomicBlock = AtomicBlockUtils.insertAtomicBlock(
		editorStateWithNewContent,
		entityKey,
		name,
	);
	setEditorState(editorStateWithNewAtomicBlock);

	return entityKey;
}



// WEBPACK FOOTER //
// ./lib/helpers/insertImage.js